// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J4oMW","field":"styles_field__1bmLj","fieldCol":"styles_fieldCol__3iltK","diffCol":"styles_diffCol__A8Bak","diff":"styles_diff__2wFsM"};